import HTTP from '@/api/HTTP';
import generalTransformer from '@/services/general/filters/serverTableDataTransformer';

const URL_BASE = 'gescom/DemandeLogistique/';

export async function create(demande) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', demande);
  return response;
}

export async function createAll(demandes) {
  const response = await HTTP.post(URL_BASE + 'CreateAllAsync', demandes);
  return response;
}

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: id } });
  return response;
}

export async function update(demande) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', demande);
  return response;
}

export async function getAll(serverTabledata) {
  const inputServer = generalTransformer(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function deleteDemandeLogistique(id) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: id } });
  return response;
}

export async function updateEtatAsync(data) {
  const response = await HTTP.put(URL_BASE + 'UpdateEtatAsync', data);
  return response;
}

export async function fusionAsync(data) {
  const response = await HTTP.post(URL_BASE + 'FusionAsync', data);
  return response;
}

export async function deleteAllDemandeLogistique(ids) {
  const response = await HTTP.post(URL_BASE + 'PDeleteAllAsync', ids);
  return response;
}

export async function checkValidationLigneCommandeForDeleteAsync(payload) {
  const response = await HTTP.post(URL_BASE + 'ValidationLigneCommandeForDeleteAsync', payload);
  return response;
}

export async function transfertInformationBetweenDemandes(data) {
  const response = await HTTP.post(URL_BASE + 'TransfertInformationBetweenDemandesAsync', data);
  return response;
}
